import React from "react";
import "./Footer.css";
import { FaFacebook, FaInstagram, FaLinkedin, FaTiktok, FaYoutube } from "react-icons/fa";
import HeadsetMicIcon from "@mui/icons-material/HeadsetMic";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify"; 
import "react-toastify/dist/ReactToastify.css";



export default function Footer() {
  return (
    <footer className="footer-container">
      <ToastContainer position="bottom-right" autoClose={3000} />

      <div className="footer-top">
        <div className="footer-left">
          <h2>Contact Us</h2>
          <div className="social-media-icons">
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.instagram.com/techie_interiors/"
              className="social-link"
            >
              <FaInstagram />
              <span>Instagram</span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.tiktok.com/@techieinteriors"
              className="social-link"
            >
              <FaTiktok />
              <span>TikTok</span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.facebook.com/techieinteriors"
              className="social-link"
            >
              <FaFacebook />
              <span>Facebook</span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.youtube.com/@techieinteriors"
              className="social-link"
            >
              <FaYoutube style={{ fontSize: "15px" }} />
              <span>Youtube</span>
            </a>
            <a
              target="_blank"
              rel="noreferrer"
              href="https://www.linkedin.com/company/techieinteriors/"
              className="social-link"
            >
              <FaLinkedin />
              <span>LinkedIn</span>
            </a>
          </div>

          {/* <h2>Subscribe to Techie Interiors Newsletter</h2> */}
          {/* <div className="subscribe-container">
            <input
              type="email"
              placeholder="Enter your email"
              className="email-input"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && !isSubmitting && email) {
                  handleSubscribe();
                }
              }}
            />
            <button
              className="banner-button1"
              onClick={handleSubscribe}
              disabled={isSubmitting}
            >
              {isSubmitting ? "Subscribing..." : "Get Newsletter"}
            </button>
          </div> */}
        </div>

        <div className="footer-right">
          <div className="footer-section">
            <div className="help-section">
              <div className="help-left">
                <div className="icon-circle">
                  <HeadsetMicIcon className="help-icon" />
                </div>
              </div>

              <div className="help-right">
                <h2>Need Help?<br />Call Now!</h2>
                <p className="phone-number">+254748600208</p>
                {/* <p className="phone-number">+254 748600208</p> */}
              </div>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <h4>Our Services</h4>
              <ul>
                <li>
                  <Link to="/gypsum-ceiling">Gypsum Ceiling Solutions</Link>
                </li>
                    <li>
                  <Link to="/services">Installation Solutions</Link>
                </li>
                <li>
                  <Link to="/wain-scouting">Wain Scouting Panels</Link>
                </li>
                <li>
                  <Link to="/tv-gypsum-wall">TV & Gypsum wall units</Link>
                </li>
                <li>
                  <Link to="/kitchen-wardrobe-fitting">Kitchen & wardrobe fitting</Link>
                </li>
                
              </ul>
            </div>
          </div>
          <div className="footer-section">
            <div>
              <h4>About Us</h4>
              <ul>
                <li>
                  <Link to="/about-us">About</Link>
                </li>
                <li>
                  <Link to="/contact-us">Contact Us</Link>
                </li>
                <li>
                  <Link to="/project">Portfolio</Link>
                </li>
                <li>
                  <Link to="/interior-design-nairobi">Interior Design Nairobi</Link>
                </li>
              </ul>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li>
                <Link to="/cookie-policy">Cookie policy</Link>
              </li>
              {/* <li>
                <a onClick={() => navigate("#")}>Manage policy</a>
              </li> */}
              <li>
                <Link to="/privacy-policy">Privacy policy</Link>
              </li>
              <li>
                <Link to="/terms-and-conditions">
                  Terms & Conditions
                </Link>
              </li>
              <li>
                <Link to="/return-policy">
                  Refund and Return Policy
                </Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <div>
              <h4>My Account</h4>
              <ul>
                <li>
                  <Link to="/profile" state={{ activeTab: 'orders' }}>Orders History</Link>
                </li>
                <li>
                  <Link to="/wishlist">Wishlist</Link>
                </li>
                <li>
                  <Link to="/profile">Profile</Link>
                </li>
              </ul>
            </div>
          </div>
        </div>          

      </div>
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Techie Interior Solutions</p>
       
      </div>
    </footer>
  );
}